import { ref, computed } from 'vue';
import { WALLET_KIND } from '@/constants/wallet';
import { walletsService } from '@/services/wallet/wallets.service';

export function useWallets() {
  const wallets = ref([]);
  const loading = ref(false);
  const error = ref(null);

  const mainWallet = computed(() => wallets.value.find((w) => w.kind === WALLET_KIND.MAIN) ?? null);
  const poolShareWallet = computed(() => wallets.value.find((w) => w.kind === WALLET_KIND.POOL_SHARE) ?? null);
  const poolCreditWallets = computed(() => wallets.value.filter((w) => w.kind === WALLET_KIND.POOL_CREDIT));
  // Aggregates across every supplier wallet — the hero shows the portfolio, the
  // per-supplier sheet shows the breakdown. `available = posted − held` is already
  // clamped ≥ 0 per-wallet by the backend (WalletResource.availableBalanceCents).
  const poolCreditTotal = computed(() =>
    poolCreditWallets.value.reduce((sum, w) => sum + (w.availableBalanceCents ?? 0), 0),
  );
  const poolCreditPostedTotal = computed(() =>
    poolCreditWallets.value.reduce((sum, w) => sum + (w.postedBalanceCents ?? 0), 0),
  );
  const poolCreditHeldTotal = computed(() =>
    poolCreditWallets.value.reduce((sum, w) => sum + (w.reservedBalanceCents ?? 0), 0),
  );

  async function refresh() {
    loading.value = true;
    error.value = null;
    try {
      const res = await walletsService.list();
      wallets.value = res.data?.data ?? [];
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  }

  return {
    mainWallet,
    poolShareWallet,
    poolCreditWallets,
    poolCreditTotal,
    poolCreditPostedTotal,
    poolCreditHeldTotal,
    loading,
    error,
    refresh,
  };
}
